__turbopack_context__.v({
  "arrow": "ScrollIndicator-module-scss-module__rFaKwq__arrow",
  "bounce": "ScrollIndicator-module-scss-module__rFaKwq__bounce",
  "circle": "ScrollIndicator-module-scss-module__rFaKwq__circle",
  "scrollIndicator": "ScrollIndicator-module-scss-module__rFaKwq__scrollIndicator",
  "text": "ScrollIndicator-module-scss-module__rFaKwq__text",
  "textRing": "ScrollIndicator-module-scss-module__rFaKwq__textRing",
});
